import { render } from "./TrainingCertificateFormat.vue?vue&type=template&id=81f302d4&ts=true"
import script from "./TrainingCertificateFormat.vue?vue&type=script&lang=ts"
export * from "./TrainingCertificateFormat.vue?vue&type=script&lang=ts"

import "./TrainingCertificateFormat.vue?vue&type=style&index=0&id=81f302d4&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__